import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const restorePersonalChat = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {},
  permissions: {
    none: "personal chats are read and written only for ctx.userId",
  },
  description: "Returns a deleted chat to the owner’s chat history.",
  interactionType: "update",
  fn: async ({ tx, ctx, args }) => {
    const chat = await tx.run(
      zql.personalChats
        .where("id", args.id)
        .where("userId", ctx.userId)
        .where("tenantId", ctx.tenantId)
        .where("deletedAt", "IS NOT", null)
        .one()
    );
    if (!chat) return;
    await tx.mutate.personalChats.update({
      id: chat.id,
      deletedAt: null,
      closedAt: null,
    });
  },
});
